import * as React from 'react';

export class DefaultDropdownItemElement extends React.Component {
  render() {
    const { highlighted, selected, ...htmlBag } = this.props;
    return <div {...htmlBag} className="default-dropdown-item-element" />;
  }
}
